import React from 'react';
import PropTypes from 'prop-types';

import Loader from '../loader';

import './style.scss';

const LoaderButton = ({ disabled, children, className, loading, ...rest }) => (
  <button type="button" disabled={disabled || loading} className={`P-loader-button ${className || ''}`} {...rest}>
    {loading ? <Loader /> : children}
  </button>
);

LoaderButton.propTypes = {
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.node,
};

export default LoaderButton;
